import React from 'react';
import { Row } from 'react-bootstrap';
import LanguageSection from '../../PersonalData/PersonalData/LanguageSection';
import HideMyBirthday from '../../PersonalData/PersonalData/HideMyBirthday';

type Props = {};

export const General: React.FC<React.PropsWithChildren<Props>> = () => {
  return (
    <Row>
      <LanguageSection />
      <HideMyBirthday />
    </Row>
  );
};
